import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import PermissaoUsuario from '../../auth/permissao';
import { createTipo, updateTipo, resetTipoForm } from './inventarioActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Grid from '../../common/layout/grid';
import Button from '../../common/form/button';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';
import { filtrarPorTexto, premiumBadge } from '../manutencaoListUtils';

const FILTRO_TODOS = '';
const selector = formValueSelector('inventarioTipoForm');

class InventarioTipoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroBusca: '',
      filtroCategoria: FILTRO_TODOS,
      filtroAtivo: FILTRO_TODOS,
      paginaAtual: 0,
    };
    this.toggleAtivo = this.toggleAtivo.bind(this);
    this.editar = this.editar.bind(this);
    this.salvar = this.salvar.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.categorias !== prevProps.categorias &&
      this.props.categorias.length > 0 &&
      !this.props.editingId &&
      !this.props.initialCategoriaId
    ) {
      this.props.resetTipoForm(this.props.categorias);
    }
  }

  salvar(values) {
    if (values.id) {
      this.props.updateTipo({ id: values.id }, values);
      return;
    }
    this.props.createTipo(values);
  }

  editar(tipo) {
    this.props.resetTipoForm({
      id: tipo.id,
      nome: tipo.nome,
      descricao: tipo.descricao || '',
      equipamento_categoria_id: tipo.equipamento_categoria_id,
      ativo: tipo.ativo,
    });
  }

  getCategoriasParaForm() {
    const { categorias, editingCategoriaId } = this.props;
    const ativas = (categorias || []).filter(c => c.ativo);
    if (!editingCategoriaId) return ativas;

    const atual = (categorias || []).find(c => String(c.id) === String(editingCategoriaId));
    if (atual && !ativas.find(c => c.id === atual.id)) {
      return [...ativas, atual];
    }
    return ativas;
  }

  getCategoriasAtivas() {
    return (this.props.categorias || []).filter(c => c.ativo);
  }

  toggleAtivo(tipo) {
    this.props.updateTipo(tipo, { ativo: !tipo.ativo });
  }

  getTiposFiltrados() {
    const { tipos } = this.props;
    let lista = tipos || [];
    lista = filtrarPorTexto(lista, ['nome', 'descricao', 'categoria_nome'], this.state.filtroBusca);
    if (this.state.filtroCategoria) {
      lista = lista.filter(t => String(t.equipamento_categoria_id) === this.state.filtroCategoria);
    }
    if (this.state.filtroAtivo !== FILTRO_TODOS) {
      const esperado = this.state.filtroAtivo === '1';
      lista = lista.filter(t => !!t.ativo === esperado);
    }
    return lista;
  }

  renderStats(total, ativos) {
    return (
      <div className="inventario-tipos-stats">
        <span>
          <strong>{total}</strong> tipos cadastrados
        </span>
        <span>
          <strong>{ativos}</strong> ativos
        </span>
      </div>
    );
  }

  renderFiltros() {
    const { filtroBusca, filtroCategoria, filtroAtivo } = this.state;
    const categorias = this.getCategoriasAtivas();

    return (
      <div className="os-list-filters-bar inventario-tipos-filters">
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="inv-tipo-busca">
            Buscar
          </label>
          <input
            id="inv-tipo-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroBusca}
            onChange={e => this.setState({ filtroBusca: e.target.value, paginaAtual: 0 })}
            placeholder="Nome ou descrição..."
          />
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label">Categoria</label>
          <select
            className="form-control os-list-filter-select"
            value={filtroCategoria}
            onChange={e => this.setState({ filtroCategoria: e.target.value, paginaAtual: 0 })}
          >
            <option value={FILTRO_TODOS}>Todas</option>
            {categorias.map(c => (
              <option key={c.id} value={String(c.id)}>
                {c.nome}
              </option>
            ))}
          </select>
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label">Situação</label>
          <select
            className="form-control os-list-filter-select"
            value={filtroAtivo}
            onChange={e => this.setState({ filtroAtivo: e.target.value, paginaAtual: 0 })}
          >
            <option value={FILTRO_TODOS}>Todas</option>
            <option value="1">Ativos</option>
            <option value="0">Inativos</option>
          </select>
        </div>
      </div>
    );
  }

  renderForm() {
    const { editingId } = this.props;
    const isEdit = !!editingId;
    const categorias = this.getCategoriasParaForm();

    return (
      <PermissaoUsuario tela="CadManutencaoInventario" campo="tipos" condicao={true}>
        <form onSubmit={this.props.handleSubmit(this.salvar)} className="simple-cad-form-premium manutencao-cad-premium inventario-tipos-form">
          <div className="simple-cad-premium-container">
            <div className="simple-cad-premium-card">
              <div className="simple-cad-premium-header">
                <h4>
                  <i className="fa fa-tags" /> {isEdit ? 'Editar tipo de equipamento' : 'Novo tipo de equipamento'}
                </h4>
                <p>Classificações reutilizáveis para o inventário instalado nos cruzamentos.</p>
              </div>
              <div className="simple-cad-premium-body inventario-tipos-form-grid">
                <Field name="nome" component={LabelAndInput} label="Nome" cols="12 4" placeholder="Ex.: Sensor de chuva" />
                <Field name="equipamento_categoria_id" component={LabelAndSelectForm} label="Categoria" cols="12 3">
                  {categorias.length === 0 ? (
                    <option value="">Cadastre uma categoria antes</option>
                  ) : (
                    categorias.map(c => (
                      <option key={c.id} value={String(c.id)}>
                        {c.nome}
                      </option>
                    ))
                  )}
                </Field>
                <Field name="descricao" component={LabelAndInput} label="Descrição" cols="12 3" placeholder="Opcional" />
                <Grid cols="12 1" className="inventario-tipos-form-action">
                  <Button
                    type="submit"
                    className="primary"
                    icon={isEdit ? 'save' : 'plus'}
                    label={isEdit ? 'Salvar' : 'Adicionar'}
                    disabled={categorias.length === 0}
                  />
                </Grid>
                {isEdit && (
                  <Grid cols="12 1" className="inventario-tipos-form-action">
                    <Button
                      type="button"
                      className="default"
                      icon="times"
                      label="Cancelar"
                      onClick={() => this.props.resetTipoForm(this.props.categorias)}
                    />
                  </Grid>
                )}
              </div>
            </div>
          </div>
        </form>
      </PermissaoUsuario>
    );
  }

  renderAcoes(row) {
    const item = row.original;

    return (
      <div className="os-actions-cell">
        <div className="os-actions-group">
          <PermissaoUsuario tela="CadManutencaoInventario" campo="tipos" condicao={true}>
            <SPButton
              type="button"
              className="warning btn-sm"
              icon="pencil-alt"
              data-title="Alterar"
              onClick={() => this.editar(item)}
            />
            <SPButton
              type="button"
              className={item.ativo ? 'default btn-sm' : 'success btn-sm'}
              icon={item.ativo ? 'eye-slash' : 'eye'}
              data-title={item.ativo ? 'Desativar' : 'Ativar'}
              onClick={() => this.toggleAtivo(item)}
            />
          </PermissaoUsuario>
        </div>
      </div>
    );
  }

  render() {
    const filtrados = this.getTiposFiltrados();
    const total = (this.props.tipos || []).length;
    const ativos = (this.props.tipos || []).filter(t => t.ativo).length;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => this.renderAcoes(row),
        className: 'column_icon',
        width: 90,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Nome',
        accessor: 'nome',
        className: 'column_grid manutencao-col-texto',
        minWidth: 180,
      },
      {
        Header: 'Categoria',
        accessor: 'categoria_nome',
        className: 'column_grid',
        width: 140,
        Cell: row =>
          premiumBadge(row.value || '—', row.original.categoria_badge || 'os-badge--gray'),
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        className: 'column_grid manutencao-col-texto',
        minWidth: 200,
        Cell: row => row.value || '—',
      },
      {
        Header: 'Situação',
        accessor: 'ativo',
        className: 'column_grid',
        width: 110,
        Cell: row =>
          premiumBadge(row.value ? 'Ativo' : 'Inativo', row.value ? 'os-badge--green' : 'os-badge--gray'),
      },
    ];

    return (
      <div className="manutencao-premium-list inventario-tipos-premium">
        <div className="inventario-tipos-intro">
          <div>
            <h4 className="inventario-tipos-title">
              <i className="fa fa-toolbox" /> Catálogo de tipos
            </h4>
            <p>Tipos de equipamento semafórico — distintos do estoque de materiais de consumo.</p>
          </div>
          {this.renderStats(total, ativos)}
        </div>

        {this.renderForm()}
        {this.renderFiltros()}

        <PremiumTableShell>
          <ReactTableGT2A
            data={filtrados}
            columns={columns}
            page={this.state.paginaAtual}
            onPageChange={page => this.setState({ paginaAtual: page })}
            defaultPageSize={12}
            minRows={3}
            noDataText="Nenhum tipo encontrado."
          />
        </PremiumTableShell>
      </div>
    );
  }
}

InventarioTipoList = reduxForm({
  form: 'inventarioTipoForm',
  destroyOnUnmount: false,
  initialValues: { equipamento_categoria_id: '', ativo: '1', nome: '', descricao: '' },
})(InventarioTipoList);

const mapStateToProps = state => ({
  tipos: state.manutencaoInventario.tipos,
  categorias: state.manutencaoInventario.categorias,
  editingId: selector(state, 'id'),
  editingCategoriaId: selector(state, 'equipamento_categoria_id'),
  initialCategoriaId: state.form.inventarioTipoForm && state.form.inventarioTipoForm.values
    ? state.form.inventarioTipoForm.values.equipamento_categoria_id
    : '',
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createTipo, updateTipo, resetTipoForm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InventarioTipoList);
